import React from 'react';
import TypedList from './TypedList';

const OPTIONS = [
  { value: 'employer-retirement', label: 'Employer Retirement Plans' },
  { value: 'ira', label: 'Individual Retirement Accounts' },
  { value: 'annuity-tax-deferred', label: 'Annuities & Tax-Deferred Products' },
  { value: 'taxable', label: 'Taxable and/or Tax-Free Accounts' },
  { value: 'college-savings', label: 'College Saving Plans' },
  { value: 'hsa', label: 'Health Savings Plan' },
];

export default function InvestmentAccountsStep({ formData, updateFormData }) {
  return (
    <div data-testid="investment-accounts-step">
      <h2 className="text-2xl font-bold text-[#0f172a] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
        Investment Accounts
      </h2>
      <p className="text-sm text-[#64748b] mb-6">Add each of your investment accounts individually.</p>
      <TypedList
        title="Accounts"
        items={formData.accounts}
        onChange={(v) => updateFormData({ ...formData, accounts: v })}
        typeOptions={OPTIONS}
        amountLabel="Current Balance"
        itemLabel="Account"
        testIdPrefix="investment-account"
      />
    </div>
  );
}
